import {initReactI18next} from 'react-i18next';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export const i18nextInst = i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
    // debug: true, // Enable debug to print out more infomation
      fallbackLng: 'en-US', // default fallbackLng is 'dev'
      // ns: ['translation'], // default namespace is 'translation'
      // nsSeparator: ':', // default namespace separator is ':'
      // keySeparator: '.', // default key separator is '.'
      interpolation: {
        // prefix: '{{', // default prefix for interpolation is '{{'
        // suffix: '}}', // default suffix for interpolation is '}}'
      },
      react: {
        useSuspense: false,
      },
    });

// This can be use for testing
// Change language based on browser setting
// i18next.changeLanguage(navigator.language);
